import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useOutletContext } from "react-router-dom";
import { bindActionCreators } from "redux";
// components
import { CustomFormInput } from "@gl-shared/shared/ui";
import { CustomButton } from "@gl-shared/shared/ui";
import { CustomFormDropdown } from "@gl-shared/shared/ui";
// actions
import { employeesActionCreators } from "../../common/store/modules/employeesModule";
// helpers
import { hotelPanelRootUrl, pagesUrl } from "../../common/utils/panel-helpers/helpers";

const AddEmployee = props => {
  const navigate = useNavigate();
  const outletContext = useOutletContext();

  const [employeeName, setEmployeeName] = useState("");
  const [employeeInitials, setEmployeeInitials] = useState("");
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [selectedConcierge, setSelectedConcierge] = useState({});
  const [errorField, setErrorField] = useState({
    name: false,
    initials: false,
    selectedConcierge: false
  });
  let conciergeList = [];
  for (let concierge of props.allConcierges) {
    conciergeList.push({
      value: concierge.id,
      label: concierge.full_name
    });
  }

  const handleConciergeChange = selectedConcierge => {
    setSelectedConcierge(selectedConcierge);
  };

  const handleSubmit = async () => {
    let errorCheck = true;
    let errorField = {
      name: false,
      initials: false,
      selectedConcierge: false
    };

    if (employeeName === "") {
      errorCheck = false;
      errorField.name = true;
    }
    if (employeeInitials === "") {
      errorCheck = false;
      errorField.initials = true;
    }
    if (Object.keys(selectedConcierge).length === 0) {
      errorCheck = false;
      errorField.selectedConcierge = true;
    }
    setErrorField(errorField);

    if (errorCheck === false) {
      return false;
    }

    props.addEmployeeAction(
      employeeName,
      employeeInitials,
      employeeNumber,
      selectedConcierge.value,
      outletContext.handleFormMessage,
      outletContext.loadEmployees,
      navigate
    );
  };

  return (
    <div className="employees component">
      <div className="row">
        <div className="col-lg-6">
          <div className="ibox form__ibox">
            <div className="ibox-title">
              <h5>Add New Employee</h5>
            </div>
            <div className="ibox-content">
              <div className="hotel__form">
                <CustomFormInput
                  showTooltip={false}
                  name="employeeName"
                  id="name"
                  label="Name"
                  onInputChange={event => setEmployeeName(event.target.value)}
                  errorField={errorField}
                  isRequired={true}
                  value={employeeName}
                />
                <CustomFormInput
                  showTooltip={false}
                  name="employeeInitials"
                  id="initials"
                  label="Initials"
                  onInputChange={event => setEmployeeInitials(event.target.value)}
                  errorField={errorField}
                  isRequired={true}
                  value={employeeInitials}
                />
                <CustomFormInput
                  showTooltip={false}
                  name="employeeNumber"
                  id="employeeNumber"
                  label="Employee Number"
                  onInputChange={event => setEmployeeNumber(event.target.value)}
                  isRequired={false}
                  value={employeeNumber}
                />
                <CustomFormDropdown
                  showTooltip={false}
                  id="selectedConcierge"
                  alignRow={true}
                  label="Concierge User"
                  selectedItem={selectedConcierge}
                  onChange={selectedConcierge => handleConciergeChange(selectedConcierge)}
                  errorField={errorField}
                  placeholder=""
                  optionsList={conciergeList}
                  isRequired={true}
                  isDisabled={false}
                  showStar={true}
                />
                <div className="form-group  row">
                  <div className="left-side" />
                  <div className="right-side">
                    <CustomButton
                      isDisabled={false}
                      mainClass="btn-gray"
                      customClasses="btn-gray--height-l"
                      onClick={() => {
                        navigate(`/${hotelPanelRootUrl}/${pagesUrl.employees}`);
                      }}
                      buttonText="CANCEL"
                    />
                    <CustomButton
                      isDisabled={false}
                      mainClass="btn-green"
                      customClasses="btn-green--height-l"
                      onClick={handleSubmit}
                      buttonText="SAVE"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  allConcierges: state.employees.allConcierges,
  selectedHotels: state.global.selectedHotels,
  isHotelGroupExists: state.home.isHotelGroupExists
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      addEmployeeAction: employeesActionCreators.addEmployeeAction
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEmployee);
